import "./loaders.scss";
import { quantum } from "ldrs";

quantum.register();

// Default values shown

const Loaders = () => {
  return (
    <div className="loaders">
      <l-quantum size="100" speed="1.75" color="black"></l-quantum>
    </div>
  );
};

export default Loaders;
